<template>
<div class="auth_layout">

<div class="auth_animation_layer animate_class " ref="auth_animation_layer">
  <img class="auth_logo " :src="headerlogo">
  <p class="animate_class auth_text" ref="auth_text">Sustainability Management System</p>
  <div class="auth_logo animate_class" ref="auth_loader">
    <img  :src="require('../../assets/Infinity-2.1s-84px.svg')" class=" " >
  </div>
  

</div>
<div class="auth_animation_bg_layer animate_class " ref="auth_animation_bg_layer">
  

</div>


<div class="auth_router_view">
  

<router-view v-slot="{ Component }">
  <transition name="routeslide" mode="out-in">
    <component :is="Component" />
  </transition>
</router-view>

</div>



</div>


</template>

<script>
export default {

  name: 'Auth',

  data () {
    return {
      headerlogo:require('../../assets/verify_logo_white.png'),
    }
  },
  mounted()
  {
    this.getLanguageData()
    setTimeout(()=>{
      let auth_animation_layer = this.$refs.auth_animation_layer
      let auth_animation_bg_layer = this.$refs.auth_animation_bg_layer
      auth_animation_layer.classList.add("auth_animation_layer_closed");
      auth_animation_bg_layer.classList.add("auth_animation_bg_layer_closed");
      let auth_loader = this.$refs.auth_loader
      let auth_text = this.$refs.auth_text
      auth_loader.classList.add("auth_loader_closed");
      auth_text.classList.add("auth_text_open");
    },10)
  }
};
</script>

<style lang="css" scoped>
</style>